import React, { Component } from 'react';
import { IAccount } from '../store/application/types';
import { Link } from 'react-router-dom'
import ContextMenu from './ContextMenu';
import { t, toggleLang, getLang } from '../i18n';

interface Props {
  account: IAccount
  workspaceName?: string
}

interface State {
  lang: string
}

class Header extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { lang: getLang() }
  }

  componentDidMount() {
    window.addEventListener('featmap_lang_change', this.onLangChange)
  }

  componentWillUnmount() {
    window.removeEventListener('featmap_lang_change', this.onLangChange)
  }

  onLangChange = () => {
    this.setState({ lang: getLang() })
  }

  handleToggleLang = () => {
    toggleLang()
    this.setState({ lang: getLang() })
  }

  render() {
    return (
      <header className="bg-gray-200">
        <div className="flex items-center p-1 ">
          <div className="flex text-lg   m-1 w-24 ">
            <b><Link to="/">Featmap</Link></b>
          </div>
          {this.props.workspaceName ?
            <div className="text-sm "><Link to={"/" + this.props.workspaceName}>{t('header_projects')}</Link></div>
            : null
          }

          <div className="flex flex-grow justify-end">
            {/* 语言切换按钮 */}
            <button
              onClick={this.handleToggleLang}
              className="flex items-center px-2 py-1 mr-1 text-xs rounded hover:bg-gray-300 text-gray-700"
              title="切换语言 / Switch language"
            >
              {t('lang_switch')}
            </button>

            <div className="flex p-1 rounded items-center">
              <ContextMenu icon="account_circle">
                <div className="rounded bg-white shadow-md absolute mt-8 z-50 top-0 right-0 min-w-full text-sm">
                  <ul className="list-reset">
                    {this.props.workspaceName ?
                      <li className="whitespace-nowrap px-4 py-2 block text-gray-600">
                        {t('header_current_ws')} <b><Link to={"/" + this.props.workspaceName}>{this.props.workspaceName}</Link></b>{' '}
                        <Link className="p-1 flex-no-shrink font-bold rounded text-xs bg-gray-300" to="/account/workspaces">{t('header_change')}</Link>
                      </li>
                      : null
                    }
                    {this.props.workspaceName ?
                      <li className="whitespace-nowrap px-4 py-2 block text-black hover:bg-gray-200">
                        <Link to={"/" + this.props.workspaceName + "/settings"}>{t('header_ws_settings')}</Link>
                      </li>
                      : null
                    }
                    <li className="whitespace-nowrap px-4 py-2 block text-black">
                      <Link to={"/account/workspaces"}>{t('header_my_workspaces')}</Link>
                    </li>
                    <li className="whitespace-nowrap block text-black">
                      <hr className="border-b" />
                    </li>
                    <li className="whitespace-nowrap px-4 py-2 block text-gray-600">
                      {t('header_logged_in_as')} <em>{this.props.account.email}</em>
                    </li>
                    <li><Link className="whitespace-nowrap px-4 py-2 block text-black hover:bg-gray-200" to="/account/settings">{t('header_account_settings')}</Link></li>
                    <li><Link className="whitespace-nowrap px-4 py-2 block text-black hover:bg-gray-200" to="/account/logout">{t('header_logout')}</Link></li>
                  </ul>
                </div>
              </ContextMenu>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
